import { useContext, useEffect, useState } from "react";
import MinusRed from "../../../../Assets/StorefrontIcons/MinusRed.svg";
import { closeModal } from "../../../../Features/inventoryManagementSlice";
import { useDispatch } from "react-redux";
import { getSizeChartColumnWidth } from "../../../../lib/utils/utils";
import InputSection from "./InputSection";
import HeaderSection from "./HeaderSection";
import { AddSizeChartContext } from "../../../../Context/AddSizeChartContext";

function ColumnRemoveModal() {
    const dispatch = useDispatch();
    const [localData, setLocalData] = useState([]);
    const [categoryKeys, setCategoryKeys] = useState([]);

    const { selectedCategory, sizeChartFormData, setSizeChartFormData } = useContext(AddSizeChartContext);

    const handleRemoveColumn = (key) => {
        const updatedData = localData.map((item) => {
            const newItem = { ...item };
            delete newItem[key];
            return newItem;
        });

        setLocalData(updatedData);
        setCategoryKeys((prevKeys) => prevKeys.filter((k) => k !== key));
    };

    useEffect(() => {
        if (sizeChartFormData.length > 0) {
            setLocalData(sizeChartFormData);
        }
    }, [sizeChartFormData]);

    useEffect(() => {
        if (sizeChartFormData.length === 0) return;
        const currentKeys = Object.keys(sizeChartFormData[0]).filter((k) => k !== "id");
        setCategoryKeys(currentKeys);
    }, [sizeChartFormData]);

    const handleSave = () => {
        setSizeChartFormData(localData);
        dispatch(closeModal());
    };

    const handleCloseModal = () => {
        dispatch(closeModal());
    };

    return (
        <div className="max-w-full flex flex-col gap-3">
            <div className="w-full flex flex-col gap-3 overflow-x-scroll">
                <div className="w-fit flex items-center">
                    {categoryKeys.map((key) => {
                        if (key === "sizeName") {
                            return <div key={key} className="w-[180px]" />;
                        } else {
                            return (
                                <div key={key} className="w-[180px] flex justify-center">
                                    <button onClick={() => handleRemoveColumn(key)} className="py-2">
                                        <img src={MinusRed} alt="" />
                                    </button>
                                </div>
                            );
                        }
                    })}
                </div>

                <div className="w-fit flex items-center rounded-lg border border-[#EAEAEA]">
                    {categoryKeys.map((key, index) => {
                        const isLast = index === categoryKeys.length - 1;
                        const columnWidth = getSizeChartColumnWidth(key, selectedCategory);

                        if (key === "sizeName") {
                            return (
                                <div
                                    key={key}
                                    className={`w-[180px] ${columnWidth || ""} h-[94px] shrink-0 px-6 py-3 flex items-center justify-center ${
                                        !isLast ? "border-r border-[#EAEAEA]" : ""
                                    }`}
                                >
                                    <p>Size</p>
                                </div>
                            );
                        }

                        return (
                            <HeaderSection
                                key={`header-${key}`}
                                isLast={isLast}
                                title={key
                                    .replace(/([A-Z])/g, " $1")
                                    .replace(/^./, (s) => s.toUpperCase())}
                                externalCSS={columnWidth}
                            />
                        );
                    })}
                </div>

                <div className="max-h-80 flex flex-col gap-3">
                    {localData.length > 0 &&
                        localData.map((row) => (
                            <div key={row.id} className="flex items-center w-fit">
                                <div className="flex items-center rounded-lg border border-[#EAEAEA]">
                                    {categoryKeys.map((key, keyIndex) => {
                                        const isLastColumn = keyIndex === categoryKeys.length - 1;
                                        const columnWidth = getSizeChartColumnWidth(key, selectedCategory);

                                        if (key === "sizeName") {
                                            return (
                                                <div
                                                    key={`${row.id}-${key}`}
                                                    className={`w-[180px] ${columnWidth || ""} shrink-0 px-6 py-3 ${
                                                        !isLastColumn ? "border-r border-[#EAEAEA]" : ""
                                                    }`}
                                                >
                                                    <p
                                                        className={`${
                                                            row.sizeName ? "" : "text-[#A0A0A0]"
                                                        } w-full text-center`}
                                                    >
                                                        {row.sizeName || "input"}
                                                    </p>
                                                </div>
                                            );
                                        }

                                        return (
                                            <InputSection
                                                key={`${row.id}-${key}-input`}
                                                isLast={isLastColumn}
                                                externalCSS={columnWidth}
                                                centimeters={row?.[key]?.cm || ""}
                                                inches={row?.[key]?.in || ""}
                                            />
                                        );
                                    })}
                                </div>
                            </div>
                        ))}
                </div>
            </div>

            <div className="flex items-center justify-end gap-2">
                <button
                    onClick={handleCloseModal}
                    className="px-5 py-[10px] rounded text-[#757575] text-base font-semibold outline-none"
                >
                    Cancel
                </button>

                <button
                    onClick={handleSave}
                    className="px-5 py-[10px] rounded text-white bg-primaryColor hover:bg-primaryAccent text-base font-semibold outline-none"
                >
                    Save
                </button>
            </div>
        </div>
    );
}

export default ColumnRemoveModal;
